/* eslint-disable prettier/prettier */
import React from "react";

const MorningIcon = ({ onClickHandle }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2403_1182)">
      <rect x="4" y="4" width="16" height="16" rx="4" fill="#FFF4BA" />
    </g>
    <path
      d="M12 6.75V7.33333V6.75ZM12 16.6667V17.25V16.6667ZM17.25 12H16.6667H17.25ZM7.33333 12H6.75H7.33333ZM15.7123 15.7123L15.2999 15.2999L15.7123 15.7123ZM8.70008 8.70008L8.28767 8.28767L8.70008 8.70008ZM15.7123 8.28767L15.2999 8.70008L15.7123 8.28767ZM8.70008 15.2999L8.28767 15.7123L8.70008 15.2999ZM14.3333 12C14.3333 12.6188 14.0875 13.2123 13.6499 13.6499C13.2123 14.0875 12.6188 14.3333 12 14.3333C11.3812 14.3333 10.7877 14.0875 10.3501 13.6499C9.9125 13.2123 9.66667 12.6188 9.66667 12C9.66667 11.3812 9.9125 10.7877 10.3501 10.3501C10.7877 9.9125 11.3812 9.66667 12 9.66667C12.6188 9.66667 13.2123 9.9125 13.6499 10.3501C14.0875 10.7877 14.3333 11.3812 14.3333 12V12Z"
      stroke="#B78400"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_2403_1182"
        x="0"
        y="0"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2403_1182"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2403_1182"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default MorningIcon;
